import { combineReducers } from 'redux';
import csrfReducer from './csrfReducer';
import roleReducer from './roleReducer';
import menuReducer from './menuReducer';
import userStateReducer from './userStateReducer';
import consentId from './consentId';
// import setReloadFeedbackDetails from './starRating';
import reloadFeedbackDetailsReducer from './reloadFeedbackDetails';
import CCEmailReducer from './CCEmailReducer';
import ResponsePendingReducer from './ResponsePendingReducer';
import surveyReducer from './surveyReducer';
import NavigatedDataReducer from './NavigatedDataReducer';
const appReducer = combineReducers({
  csrf: csrfReducer,
  role: roleReducer,
  menu: menuReducer,
  userState: userStateReducer,
  consentId: consentId,
  reloadFeedbackDetails: reloadFeedbackDetailsReducer,
  CCEmailReducer: CCEmailReducer,
  ResponsePendingReducer: ResponsePendingReducer,
  survey: surveyReducer,
  navigate: NavigatedDataReducer
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    return appReducer(undefined, action)
  }
  else return appReducer(state, action);
}
export default rootReducer;